import React from "react";
import { useDispatch } from "react-redux";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { GetCompanyByIdResponseCompanyAddress } from "../../../../models/response/company/GetCompanyByIdResponse";
import { GetCompanyListResponse, GetCompanyListResponseItem } from "../../../../models/response/company/GetCompanyListResponse";
import { storeActivityIndicator, storeFastFirm } from "../../../../redux/reducers/authSlice";
import { CompanyService } from "../../../../services/CompanyService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import AddressComponent from "./AddressComponent";
import { LocationInformationModel } from "./LocationInformation";
import toast from "react-hot-toast";

interface Props {
    firmInformationRef: any
    getCompanyById: (_companyId: string, setVariableAddressList: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAddress[]>>, setSelectedVariableAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>, setVariableAddressText: React.Dispatch<React.SetStateAction<string | undefined>>, _setDefault?: boolean, setInformation?: React.Dispatch<React.SetStateAction<LocationInformationModel>> | undefined) => Promise<void>
    selectedSenderAddressType: CustomSingleSelectModel | undefined
    selectedSenderCompany: CustomSingleSelectModel | undefined
    setSelectedSenderAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedSenderCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSenderAddressList: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAddress[]>>
    setSenderAddressText: React.Dispatch<React.SetStateAction<string | undefined>>
    senderAddressList: GetCompanyByIdResponseCompanyAddress[]
    senderAddressText: string | undefined
    selectedReceiverAddressType: CustomSingleSelectModel | undefined
    selectedReceiverCompany: CustomSingleSelectModel | undefined
    setSelectedReceiverAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedReceiverCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setReceiverAddressList: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAddress[]>>
    setReceiverAddressText: React.Dispatch<React.SetStateAction<string | undefined>>
    receiverAddressList: GetCompanyByIdResponseCompanyAddress[]
    receiverAddressText: string | undefined
    selectedLoadingAddressType: CustomSingleSelectModel | undefined
    selectedLoadingCompany: CustomSingleSelectModel | undefined
    setSelectedLoadingAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedLoadingCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setLoadingAddressList: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAddress[]>>
    setLoadingAddressText: React.Dispatch<React.SetStateAction<string | undefined>>
    loadingAddressList: GetCompanyByIdResponseCompanyAddress[]
    loadingAddressText: string | undefined
    selectedUnloadingAddressType: CustomSingleSelectModel | undefined
    selectedUnloadingCompany: CustomSingleSelectModel | undefined
    setSelectedUnloadingAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedUnloadingCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setUnloadingAddressList: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAddress[]>>
    setUnloadingAddressText: React.Dispatch<React.SetStateAction<string | undefined>>
    unloadingAddressList: GetCompanyByIdResponseCompanyAddress[]
    unloadingAddressText: string | undefined
    selectedDutyCompany: CustomSingleSelectModel | undefined
    setSelectedDutyCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedLoadingInformation: React.Dispatch<React.SetStateAction<LocationInformationModel>>
    setSelectedUnloadingInformation: React.Dispatch<React.SetStateAction<LocationInformationModel>>
}

const FirmInformation = ({
    firmInformationRef,
    getCompanyById,
    selectedSenderAddressType,
    selectedSenderCompany,
    setSelectedSenderAddressType,
    setSelectedSenderCompany,
    setSenderAddressList,
    setSenderAddressText,
    senderAddressList,
    senderAddressText,
    selectedReceiverAddressType,
    selectedReceiverCompany,
    setSelectedReceiverAddressType,
    setSelectedReceiverCompany,
    setReceiverAddressList,
    setReceiverAddressText,
    receiverAddressList,
    receiverAddressText,
    selectedLoadingAddressType,
    selectedLoadingCompany,
    setSelectedLoadingAddressType,
    setSelectedLoadingCompany,
    setLoadingAddressList,
    setLoadingAddressText,
    loadingAddressList,
    loadingAddressText,
    selectedUnloadingAddressType,
    selectedUnloadingCompany,
    setSelectedUnloadingAddressType,
    setSelectedUnloadingCompany,
    setUnloadingAddressList,
    setUnloadingAddressText,
    unloadingAddressList,
    unloadingAddressText,
    selectedDutyCompany,
    setSelectedDutyCompany,
    setSelectedLoadingInformation,
    setSelectedUnloadingInformation,
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={firmInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Firma Bilgileri</h4>

                    <AddressComponent
                        text="Gönderici Firma"
                        className="mt-0"
                        getCompanyById={getCompanyById}
                        selectedVariableAddressType={selectedSenderAddressType}
                        selectedVariableCompany={selectedSenderCompany}
                        setSelectedVariableAddressType={setSelectedSenderAddressType}
                        setSelectedVariableCompany={setSelectedSenderCompany}
                        setVariableAddressList={setSenderAddressList}
                        setVariableAddressText={setSenderAddressText}
                        variableAddressList={senderAddressList}
                        variableAddressText={senderAddressText}
                        additionalEvent={(selectedCompany) => {
                            if (selectedCompany) {
                                setSelectedLoadingCompany(selectedCompany);
                                getCompanyById(selectedCompany.value, setLoadingAddressList, setSelectedLoadingAddressType, setLoadingAddressText, true, setSelectedLoadingInformation);
                            }
                            else {
                                setSelectedLoadingCompany(undefined);
                                setSelectedLoadingAddressType(undefined);
                                setLoadingAddressText('');
                                setSelectedLoadingInformation({
                                    selectedCountry: undefined,
                                    selectedCounty: undefined,
                                    selectedDistrict: undefined
                                })
                            }
                        }}
                        setInformation={setSelectedLoadingInformation}
                        isSenderFirm
                    />

                    <AddressComponent
                        text="Alıcı Firma"
                        className="mt-5"
                        getCompanyById={getCompanyById}
                        selectedVariableAddressType={selectedReceiverAddressType}
                        selectedVariableCompany={selectedReceiverCompany}
                        setSelectedVariableAddressType={setSelectedReceiverAddressType}
                        setSelectedVariableCompany={setSelectedReceiverCompany}
                        setVariableAddressList={setReceiverAddressList}
                        setVariableAddressText={setReceiverAddressText}
                        variableAddressList={receiverAddressList}
                        variableAddressText={receiverAddressText}
                        additionalEvent={(selectedCompany) => {
                            if (selectedCompany) {
                                setSelectedUnloadingCompany(selectedCompany);
                                getCompanyById(selectedCompany.value, setUnloadingAddressList, setSelectedUnloadingAddressType, setUnloadingAddressText, true, setSelectedUnloadingInformation);
                            }
                            else {
                                setSelectedUnloadingCompany(undefined);
                                setSelectedUnloadingAddressType(undefined);
                                setUnloadingAddressText('');
                                setSelectedUnloadingInformation({
                                    selectedCountry: undefined,
                                    selectedCounty: undefined,
                                    selectedDistrict: undefined
                                })
                            }
                        }}
                        setInformation={setSelectedUnloadingInformation}
                        isReceiverFirm
                    />

                    <AddressComponent
                        text="Yükleme Firması"
                        className="mt-5"
                        getCompanyById={getCompanyById}
                        selectedVariableAddressType={selectedLoadingAddressType}
                        selectedVariableCompany={selectedLoadingCompany}
                        setSelectedVariableAddressType={setSelectedLoadingAddressType}
                        setSelectedVariableCompany={setSelectedLoadingCompany}
                        setVariableAddressList={setLoadingAddressList}
                        setVariableAddressText={setLoadingAddressText}
                        variableAddressList={loadingAddressList}
                        variableAddressText={loadingAddressText}
                        additionalEvent={(selectedCompany) => {
                            if (selectedCompany) {
                                setSelectedLoadingCompany(selectedCompany);
                                getCompanyById(selectedCompany.value, setLoadingAddressList, setSelectedLoadingAddressType, setLoadingAddressText, true, setSelectedLoadingInformation);
                            }
                            else {
                                setSelectedLoadingCompany(undefined);
                                setSelectedLoadingAddressType(undefined);
                                setLoadingAddressText('');
                                setSelectedLoadingInformation({
                                    selectedCountry: undefined,
                                    selectedCounty: undefined,
                                    selectedDistrict: undefined
                                })
                            }
                        }}
                        setInformation={setSelectedLoadingInformation}
                        isSenderFirm
                    />

                    <AddressComponent
                        text="Boşaltma Firması"
                        className="mt-5"
                        getCompanyById={getCompanyById}
                        selectedVariableAddressType={selectedUnloadingAddressType}
                        selectedVariableCompany={selectedUnloadingCompany}
                        setSelectedVariableAddressType={setSelectedUnloadingAddressType}
                        setSelectedVariableCompany={setSelectedUnloadingCompany}
                        setVariableAddressList={setUnloadingAddressList}
                        setVariableAddressText={setUnloadingAddressText}
                        variableAddressList={unloadingAddressList}
                        variableAddressText={unloadingAddressText}
                        additionalEvent={(selectedCompany) => {
                            if (selectedCompany) {
                                setSelectedUnloadingCompany(selectedCompany);
                                getCompanyById(selectedCompany.value, setUnloadingAddressList, setSelectedUnloadingAddressType, setUnloadingAddressText, true, setSelectedUnloadingInformation);
                            }
                            else {
                                setSelectedUnloadingCompany(undefined);
                                setSelectedUnloadingAddressType(undefined);
                                setUnloadingAddressText('');
                                setSelectedUnloadingInformation({
                                    selectedCountry: undefined,
                                    selectedCounty: undefined,
                                    selectedDistrict: undefined
                                })
                            }
                        }}
                        setInformation={setSelectedUnloadingInformation}
                        isReceiverFirm
                    />

                    <div className={'row mt-5'}>
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Gümrük Firması</label>

                            <CustomSingleSelect
                                selectedValue={selectedDutyCompany}
                                onChange={setSelectedDutyCompany}
                                insertable={{
                                    tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                    onClick: () => {
                                        dispatch(storeFastFirm({
                                            companyId: selectedDutyCompany?.value,
                                            isDutyFirm: true,
                                            onSubmit: async (response) => {
                                                setSelectedDutyCompany({ label: response.name, value: response.companyId })
                                            }
                                        }))
                                    }
                                }}
                                onMenuOpen={() => CompanyService.getCompanyList({ isDutyFirm: true })}
                                labelName='name'
                                valueName='companyId'
                            />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default FirmInformation;